module.exports = __webpack_public_path__ + "static/img/SearchDetailBorn3.c6309ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailBorn3.png
// module id = 711
// module chunks = 0